export default __webpack_public_path__ + "static/media/profile-color.eedf7913.svg";